import AdditionalFeeManagementTopBar from './AdditionalFeeManagementTopBar.vue';

export default AdditionalFeeManagementTopBar;
